import {Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation} from '@angular/core';


@Component({
    selector: 'modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.css']
})

export class ModalWidget {

    @Input() heading: string;
    @Input() size: string;
    @Input() type: string = "dark";
    @Output() closed: EventEmitter<any> = new EventEmitter();

    public _open;

    @Input()
    set open(val: boolean) {
        this._open = val
    }

    get open(): boolean { return this._open; }

    closeModal(): void { this._open = false; this.closed.emit(); }
}
